import { useContent } from "@/content/ContentProvider";
import React, { useState } from "react";
import PageHero from "@/components/site/PageHero";
import { Definition } from "@/components/site/Positioning";
import AboutStory from "@/components/site/AboutStory";
import { Reveal } from "@/components/site/Reveal";
import { PillButton } from "@/components/site/Kit";
import { AudienceCard, PaperCard } from "@/components/site/HomeBottom";
import WorkflowDiagram from "@/components/site/WorkflowDiagram";
export function Audiences() {
  const { text: cmsText, AUDIENCES } = useContent();
  return (
    <>
      <PageHero
        label={cmsText("Content.Audiences.who-it-s-for.380adc")}
        title={cmsText("Content.Audiences.built-around-your-work-.8c4068")}
        text={cmsText(
          "Content.Audiences.connected-tools-can-help-where-a-repeated-job.47e0e5",
        )}
      />
      <section className="px-5 pt-20">
        <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-x-3 gap-y-16 md:grid-cols-2">
          {AUDIENCES.filter((a) => a.visibility !== "unlisted").map((a, i) => (
            <Reveal key={a.slug} delay={i * 100}>
              <AudienceCard audience={a} />
            </Reveal>
          ))}
        </div>
        <p className="mx-auto mt-12 max-w-[1400px] text-[14px] leading-[1.4] opacity-50">
          {cmsText(
            "Content.Audiences.these-are-illustrative-engagement-ideas-not-c.ac446f",
          )}
        </p>
      </section>
    </>
  );
}
export function Insights() {
  const { text: cmsText, PAPERS } = useContent();
  const publicPapers = PAPERS.filter((p) => p.visibility !== "unlisted");
  const cats = ["all", ...new Set(publicPapers.map((p) => p.cat))];
  const [cat, setCat] = useState("all");
  const list =
    cat === "all" ? publicPapers : publicPapers.filter((p) => p.cat === cat);
  return (
    <>
      <PageHero
        label={cmsText("Content.Insights.notes.704400")}
        title={cmsText("Content.Insights.notes-on-connected-work-.fed7c4")}
        text={cmsText(
          "Content.Insights.practical-principles-for-internal-tools-agent.32f14c",
        )}
      />
      <section className="px-5 pt-14">
        <div className="mx-auto max-w-[1400px]">
          <div className="flex flex-wrap gap-2" data-testid="insight-filters">
            {cats.map((c) => (
              <button
                key={c}
                type="button"
                onClick={() => setCat(c)}
                data-testid={`filter-${c.toLowerCase().replace(/\s/g, "-")}`}
                className={`h-9 rounded-full px-5 text-[12px] font-medium transition-colors ${cat === c ? "bg-black text-white" : "bg-[#f7f7f7] hover:bg-black hover:text-white"}`}
              >
                {c === "all" ? cmsText("Content.all-notes-filter") : c}
              </button>
            ))}
          </div>
          <div className="mt-12 grid gap-x-3 gap-y-12 md:grid-cols-3">
            {list.map((p) => (
              <Reveal key={p.id}>
                <PaperCard p={p} />
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
export function About() {
  const { text: cmsText, nextLayout } = useContent();
  return (
    <>
      <PageHero
        label={cmsText("Content.About.about-nomus.0cc569")}
        title={cmsText(
          "Content.About.connected-tools-clear-responsibility-.4fcaf6",
        )}
        text={cmsText(
          "Content.About.we-build-internal-tools-that-people-and-agent.388fa5",
        )}
      />
      {nextLayout && <Definition linkTo="/#monday" />}
      {nextLayout && <AboutStory />}
      {!nextLayout && (
        <section className="px-5 pt-20">
          <div className="mx-auto grid max-w-[1400px] gap-8 lg:grid-cols-12">
            <Reveal className="lg:col-span-6">
              <h2 className="nm-title text-[30px] leading-[1.08] sm:text-[44px]">
                {cmsText(
                  "Content.About.connected-applications-are-the-starting-point.6c9f47",
                )}
              </h2>
              <p className="mt-6 text-[18px] leading-[1.45] opacity-60">
                {cmsText(
                  "Content.About.we-ve-built-multiple-internal-applications-co.db26e9",
                )}
              </p>
              <p className="mt-5 text-[18px] leading-[1.45] opacity-60">
                {cmsText(
                  "Content.About.for-your-business-the-starting-point-is-a-use.df973b",
                )}
              </p>
              <div className="mt-8">
                <PillButton to="/contact">
                  {cmsText("Content.About.discuss-your-workflow.184fa5")}
                </PillButton>
              </div>
            </Reveal>
            <Reveal className="min-h-[400px] overflow-hidden rounded-[24px] lg:col-span-5 lg:col-start-8">
              <WorkflowDiagram />
            </Reveal>
          </div>
          <div className="mx-auto mt-24 grid max-w-[1400px] gap-3 md:grid-cols-3">
            {[
              [
                cmsText("Content.About.clear-responsibility.9705d2"),
                cmsText(
                  "Content.About.we-handle-design-implementation-and-handover-.7ce93f",
                ),
              ],
              [
                cmsText("Content.About.a-clear-scope.d07328"),
                cmsText(
                  "Content.About.one-workflow-first-with-defined-systems-respo.2b612a",
                ),
              ],
              [
                cmsText("Content.About.useful-ownership.5e7f2f"),
                cmsText(
                  "Content.About.documentation-review-points-and-an-agreed-pla.8a8a4d",
                ),
              ],
            ].map(([h, t]) => (
              <Reveal key={h} className="rounded-[24px] bg-[#f7f7f7] p-8">
                <h3 className="nm-title text-[36px]">{h}</h3>
                <p className="mt-3 text-[16px] leading-[1.4] opacity-60">{t}</p>
              </Reveal>
            ))}
          </div>
        </section>
      )}
    </>
  );
}
